const technologieLogos = [
  { id: 0, name: "javascript", src: "logos/javascript-logo.svg" },
  { id: 1, name: "react", src: "logos/react-logo.svg" },
  { id: 2, name: "redux", src: "logos/redux-logo.svg" },
  { id: 3, name: "svelte", src: "logos/svelte-logo.svg" },
  { id: 4, name: "sass", src: "logos/sass-logo.svg" },
  { id: 5, name: "bootstrap", src: "logos/bootstrap-logo.svg" },
  { id: 6, name: "css", src: "logos/css-logo.svg" },
  { id: 7, name: "html", src: "logos/html-logo.svg" },
  { id: 8, name: "wordpress", src: "logos/wordpress-logo.svg" },
];

const toolLogos = [
  { id: 0, name: "vscode", src: "logos/vscode-logo.svg" },
  { id: 1, name: "netlify", src: "logos/netlify-logo.svg" },
  { id: 2, name: "github", src: "logos/github-logo.svg" },
  { id: 3, name: "git", src: "logos/git-logo.svg" },
  { id: 4, name: "npm", src: "logos/npm-logo.svg" },
  { id: 5, name: "discord", src: "logos/discord-logo.svg" },
  { id: 6, name: "trello", src: "logos/trello-logo.svg" },
  { id: 7, name: "illustrator", src: "logos/illustrator-logo.svg" },
  { id: 8, name: "figma", src: "logos/figma-logo.svg" },
];

export { technologieLogos, toolLogos };
